import { FormWarning } from 'components';
import { useTranslation } from 'react-i18next';
import useClient from '../../hooks/useClient';

export default function CreditLimitWarningBox() {
  const { client } = useClient();
  const { t } = useTranslation('notification');
  if (!client?.creditLimit) return null;
  return (
    <FormWarning
      title={t('ageRestriction.title', {
        creditLimit: client?.creditLimit,
      })}
    />
  );
}
